module.exports = __webpack_public_path__ + "static/media/Things to Know Before You Go_Attendees- FDC2021_1618846415882.30508fc0.docx";